var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsxs, jsx } from "react/jsx-runtime";
import { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import ChatLine from "./ChatLine.js";
import ChatIcon from "./ChatIcon.js";
class ChatView extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "scrollToBottom", (behavior = "smooth") => {
      if (!this.msgEnd) {
        return;
      }
      this.msgEnd.scrollIntoView({ behavior });
    });
  }
  componentDidMount() {
    this.scrollToBottom("auto");
    window.addEventListener("resize", () => {
      this.scrollToBottom();
    });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", () => {
      this.scrollToBottom();
    });
  }
  componentDidUpdate() {
    setTimeout(() => {
      this.scrollToBottom("smooth");
    }, 400);
  }
  renderTypingNotification() {
    if (this.props.sending) {
      return /* @__PURE__ */ jsxs("div", { className: "chat-line receiver-line typing-line", children: [
        /* @__PURE__ */ jsx(ChatIcon, {}),
        /* @__PURE__ */ jsx("div", { className: "chat-block", children: /* @__PURE__ */ jsx("div", { className: "chat-bubble typing-bubble", children: [...Array(3)].map((_, i) => /* @__PURE__ */ jsx("span", { className: "dot" }, i)) }) })
      ] });
    }
    return null;
  }
  render() {
    const previousMessages = this.props.previousmessages.map(
      (msgArr, index) => {
        return /* @__PURE__ */ jsx(ChatLine, { message: msgArr }, index);
      }
    );
    const messages = this.props.messages.map((msgArr, index) => {
      return /* @__PURE__ */ jsx(ChatLine, { message: msgArr }, index);
    });
    return /* @__PURE__ */ jsxs(
      "div",
      {
        id: "chat-view",
        className: this.props.className || "",
        ...this.props,
        children: [
          previousMessages,
          /* @__PURE__ */ jsx("h4", { id: "chat-view-date-header", children: moment().format("MMMM D, YYYY") }),
          messages,
          this.renderTypingNotification(),
          /* @__PURE__ */ jsx(
            "div",
            {
              id: "message-scroll-anchor",
              ref: (el) => {
                this.msgEnd = el;
              }
            }
          )
        ]
      }
    );
  }
}
ChatView.propTypes = {
  previousmessages: PropTypes.array,
  agenttyping: PropTypes.bool,
  sending: PropTypes.bool,
  messages: PropTypes.array,
  className: PropTypes.string
};
export {
  ChatView as default
};
//# sourceMappingURL=ChatView.js.map
